// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none"
// @generated from file public/catalog.proto (package public, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { CountryPublicMessage } from "../common/common_pb";
import { file_common_common } from "../common/common_pb";
import type { PairMessage } from "../common/trading_pb";
import { file_common_trading } from "../common/trading_pb";
import type { EmptySchema } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_empty } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file public/catalog.proto.
 */
export const file_public_catalog: GenFile = /*@__PURE__*/
  fileDesc("ChRwdWJsaWMvY2F0YWxvZy5wcm90bxIGcHVibGljIjoKFExpc3RDb3VudHJpZXNSZXF1ZXN0EhUKCGxhbmd1YWdlGAEgASgJSACIAQFCCwoJX2xhbmd1YWdlIjYKEUxpc3RQYWlyc1Jlc3BvbnNlEiEKBGRhdGEYASADKAsyEy5jb21tb24uUGFpck1lc3NhZ2UiQwoVTGlzdENvdW50cmllc1Jlc3BvbnNlEioKBGRhdGEYASADKAsyHC5jb21tb24uQ291bnRyeVB1YmxpY01lc3NhZ2UyoQEKEUNhdGFsb2dSUENTZXJ2aWNlEj4KCUxpc3RQYWlycxIWLmdvb2dsZS5wcm90b2J1Zi5FbXB0eRoZLnB1YmxpYy5MaXN0UGFpcnNSZXNwb25zZRJMCg1MaXN0Q291bnRyaWVzEhwucHVibGljLkxpc3RDb3VudHJpZXNSZXF1ZXN0Gh0ucHVibGljLkxpc3RDb3VudHJpZXNSZXNwb25zZWIGcHJvdG8z", [file_common_common, file_common_trading, file_google_protobuf_empty]);

/**
 * @generated from message public.ListCountriesRequest
 */
export type ListCountriesRequest = Message<"public.ListCountriesRequest"> & {
  /**
   * @generated from field: optional string language = 1;
   */
  language?: string;
};

/**
 * Describes the message public.ListCountriesRequest.
 * Use `create(ListCountriesRequestSchema)` to create a new message.
 */
export const ListCountriesRequestSchema: GenMessage<ListCountriesRequest> = /*@__PURE__*/
  messageDesc(file_public_catalog, 0);

/**
 * @generated from message public.ListPairsResponse
 */
export type ListPairsResponse = Message<"public.ListPairsResponse"> & {
  /**
   * @generated from field: repeated common.PairMessage data = 1;
   */
  data: PairMessage[];
};

/**
 * Describes the message public.ListPairsResponse.
 * Use `create(ListPairsResponseSchema)` to create a new message.
 */
export const ListPairsResponseSchema: GenMessage<ListPairsResponse> = /*@__PURE__*/
  messageDesc(file_public_catalog, 1);

/**
 * @generated from message public.ListCountriesResponse
 */
export type ListCountriesResponse = Message<"public.ListCountriesResponse"> & {
  /**
   * @generated from field: repeated common.CountryPublicMessage data = 1;
   */
  data: CountryPublicMessage[];
};

/**
 * Describes the message public.ListCountriesResponse.
 * Use `create(ListCountriesResponseSchema)` to create a new message.
 */
export const ListCountriesResponseSchema: GenMessage<ListCountriesResponse> = /*@__PURE__*/
  messageDesc(file_public_catalog, 2);

/**
 * @generated from service public.CatalogRPCService
 */
export const CatalogRPCService: GenService<{
  /**
   * @generated from rpc public.CatalogRPCService.ListPairs
   */
  listPairs: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof ListPairsResponseSchema;
  },
  /**
   * @generated from rpc public.CatalogRPCService.ListCountries
   */
  listCountries: {
    methodKind: "unary";
    input: typeof ListCountriesRequestSchema;
    output: typeof ListCountriesResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_public_catalog, 0);

